import { NSARouterMakerResult, NSAPlanStatus } from 'namirasoft-account-react';
import { PaymentBase, SalesItemFullRow } from 'namirasoft-payment';
import { useEffect, useState } from 'react';
import { PaymentProps } from '../PaymentProps';
import Styles from './NSPPlanStatusList.module.css';

export interface NSPPlanStatusListProps extends NSARouterMakerResult, PaymentProps
{ }

// subscription based sales items that are always listed, even if the user has never subscribed to them
const MEMBERSHIP_SALES_ITEM_IDS = [
    PaymentBase.NAMIRASOFT_SUPPORT.sales_items.MEMBERSHIP.id,
    PaymentBase.NAMIRASOFT_JOB_ARRANGER.sales_items.MEMBERSHIP.id,
];

interface NSPPlanStatusListState
{
    loading: boolean;
    sales_items: SalesItemFullRow[];
}

function NSPPlanStatusList(props: NSPPlanStatusListProps)
{
    let [state, setState] = useState<NSPPlanStatusListState>({ loading: true, sales_items: [] });

    useEffect(() =>
    {
        let mounted = true;
        let load = async () =>
        {
            let server = props.servers.payment;
            let subscriptions = await server.subscription.List(null, 1, 100, [], null).catch(() => null);
            let ids = Array.from(new Set([...MEMBERSHIP_SALES_ITEM_IDS, ...(subscriptions?.rows ?? []).map(s => s.sales_item_id)]));
            let sales_items = await Promise.all(ids.map(id => server.sales_item.Get(id).catch(() => null)));
            let rows = sales_items.filter((s): s is SalesItemFullRow => !!s);
            rows.sort((a, b) => (a.product?.name ?? "").localeCompare(b.product?.name ?? "") || a.order - b.order);
            if (mounted)
                setState({ loading: false, sales_items: rows });
        };
        load();
        return () => { mounted = false; };
        // eslint-disable-next-line
    }, []);

    if (state.loading)
        return <span className={Styles.nsp_plans_loading}>Loading plans . . .</span>;

    if (state.sales_items.length === 0)
        return null;

    return (
        <section className={Styles.nsp_plans}>
            <h2 className={Styles.nsp_plans_title}>Your plans</h2>
            <div className={Styles.nsp_plans_grid}>
                {
                    state.sales_items.map(sales_item => (
                        <div key={sales_item.id} className={Styles.nsp_plans_item}>
                            <div className={Styles.nsp_plans_product}>
                                {
                                    (sales_item.product?.logo || sales_item.logo) &&
                                    <img src={sales_item.product?.logo || sales_item.logo} alt="" width={24} height={24} />
                                }
                                <span>{sales_item.product?.name ?? sales_item.name}</span>
                            </div>
                            <NSAPlanStatus {...props} sales_item_id={sales_item.id} />
                        </div>
                    ))
                }
            </div>
        </section>
    );
}

export default NSPPlanStatusList;